export default function (quote) {
  return !!quote?.milesQuoteRef;
}
